export enum DateSplitter {
  Dash = '-',
  Slash = '/',
  Dot = '.'
}
